import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Shield, Users, Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/LanguageContext';

export const Hero = () => {
  const { t } = useLanguage();
  const trustIndicators = [
    { icon: Shield, label: 'Expertise', value: 'Legal + Tech' },
    { icon: Users, label: 'Trained', value: '500+' },
  ];

  return (
    <section className="relative min-h-[70vh] lg:min-h-[75vh] flex items-center overflow-hidden hero-bg">
      {/* Decorative orbs */}
      <div className="absolute top-20 left-10 w-72 h-72 bg-primary/10 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-10 right-10 w-96 h-96 bg-accent/8 rounded-full blur-3xl pointer-events-none" />

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24 text-center">
        {/* Tagline */}
        <div className="inline-flex items-center px-4 py-2 rounded-full bg-primary/10 border border-primary/20 mb-6 backdrop-blur-sm">
          <Sparkles className="w-4 h-4 text-primary mr-2" />
          <span className="text-sm font-medium text-primary">{t('heroTagline')}</span>
        </div>

        {/* Main heading */}
        <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-foreground leading-tight mb-6">
          {t('heroTitle')}{' '}
          <span className="gradient-text">{t('heroTitleHighlight')}</span>
        </h1>

        {/* Subtitle */}
        <p className="text-base lg:text-lg text-muted-foreground leading-relaxed max-w-2xl mx-auto mb-8">
          {t('heroSubtitle')}
        </p>

        {/* CTA */}
        <div className="flex justify-center mb-10">
          <Button asChild size="lg" className="gradient-bg text-primary-foreground hover:opacity-90 text-base lg:text-lg h-12 lg:h-14 px-6 lg:px-8 glow-primary transition-all duration-300">
            <Link to="/formation-ia-juridique-eligible-financement" className="flex items-center">
              {t('heroCtaCatalog')}
              <ArrowRight className="ml-2 w-5 h-5" />
            </Link>
          </Button>
        </div>

        {/* Trust indicators */}
        <div className="pt-8 border-t border-primary/10 max-w-md mx-auto">
          <p className="text-sm text-muted-foreground mb-4">{t('heroTrust')}</p>
          <div className="flex flex-wrap gap-6 justify-center">
            {trustIndicators.map((item, index) => (
              <div key={index} className="flex items-center space-x-2">
                <div className="w-10 h-10 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center">
                  <item.icon className="w-5 h-5 text-primary" />
                </div>
                <div className="text-left">
                  <p className="text-xs text-muted-foreground">{item.label}</p>
                  <p className="text-sm font-semibold text-foreground">{item.value}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
